module.exports = __webpack_public_path__ + "img/personal_rule.ed617e0b.png";